import React, { useState, useEffect, useRef } from "react";
import { classNames } from "primereact/utils";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Tag } from "primereact/tag";
import { TriStateCheckbox } from "primereact/tristatecheckbox";
import { InputSwitch } from "primereact/inputswitch";
import { Toast } from "primereact/toast";
import { Menu } from "primereact/menu";
import { ToggleButton } from "primereact/togglebutton";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import Spinner from "../Spinner/spinner";
import "./Table.css";
import { TableConfig } from "../../types";
import { useDispatch, useSelector } from "react-redux";
import { sendEmailNotification } from "../../services/viewTimeSheet";
import { appInsights } from "../../AppInsights";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
const ColumnType = {
  TEXT: "text",
  COUNTER: "counter",
  DATE: "date",
  SUBTEXT: "subText",
  Status: "status",
  projectType: "projectType",
  projects: "projects",
  projects1: "projects1",
};

const ActionMenu = React.memo(({ items, rowData }) => {
  const menuRef = useRef(null);
  const menuItems = items.map((item) => ({
    ...item,
    command: () => item.command(rowData),
  }));

  return (
    <div className="flex gap-2">
      <Menu model={menuItems} popup ref={menuRef} />
      <Button
        icon="pi pi-ellipsis-v"
        rounded
        text
        onClick={(e) => menuRef.current?.toggle(e)}
      />
    </div>
  );
});

function Table(props) {
  const { userData } = useSelector((state) => state.user);
  const {
    content: data,
    columnsData: columns,
    actions,
    tableStyle,
    paginatorTemplate,
    paginator = true,
    scrollable,
    header,
    checkBox,
    rows,
    footer,
    onPage,
    emptyMessage = "No records found",
    totalRecords,
    currentPageReportTemplate,
    first
  } = props;

  const [progressBar, setCopyProgressBar] = useState(false);
  const toast = useRef(null);
  const [visible, setVisible] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedProject1, setSelectedProject1] = useState(null);
  const [selectedProject2, setSelectedProject2] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const statusBodyTemplate = (rowData) => {
    const statusClass = rowData?.status?.toLowerCase()?.trim().split(' ').join('');
    return (
      <span className={`status-badge status-${statusClass}`}>
        {rowData?.status}
      </span>
    );
  };

  const renderActionColumn = (rowData, options) => {
    const columnHeader = options;

    switch (columnHeader) {
      case actions?.status?.label:
        return (
          <div className="flex gap-2 ">
            <InputSwitch
              checked={rowData.isActive}
              onChange={(e) =>
                actions?.status.onChange(rowData, !rowData.isActive)
              }
            />
          </div>
        );
      case actions?.menu?.label:
        return <ActionMenu items={actions.menu.items} rowData={rowData} />;
      case actions?.view?.label:
        return (
          <div className="flex gap-2">
            <Button
              icon="pi pi-eye"
              rounded
              text
              severity="info"
              onClick={() => actions.view.onClick(rowData)}
            />
          </div>
        );
      case actions?.email?.label:
       // const flag = rowData?.status?.toLowerCase()?.split(" ").join('')
        return (
          <div className="flex gap-2">
            <Button
              className="sendByIdBtn"
              icon="pi pi-send"
              rounded
              text
              label="Send Email"
              // tooltip="Send Reminder Email"
              severity="info"
              onClick={() => actions.email.onClick(rowData)}
            />
          </div>
        );
      case actions?.download?.label:
        return actions?.download?.enabled(rowData) &&
          rowData?.documents?.length > 0 ? (
          <div className="flex gap-2">
            <a
              style={{ cursor: "pointer", color: "blue" }}
              onClick={() => actions.download.onClick(rowData)}
            >
              View All
            </a>
          </div>
        ) : null;
      case actions?.approval?.label:
        return (
          <div className="flex gap-2">
            {rowData.status === "pending" ? (
              <>
                <Button
                  icon="pi pi-check"
                  rounded
                  text
                  className="btn-for-approve"
                  severity="success"
                  onClick={() => actions.approval.onApprove(rowData)}
                />
                <Button
                  icon="pi pi-times"
                  rounded
                  text
                  className="btn-for-reject"
                  severity="danger"
                  onClick={() => actions.approval.onReject(rowData)}
                />
              </>
            ) : (
              <span
                className={`status-badge status-${rowData.status?.toLowerCase()}`}
              >
                {rowData.status}
              </span>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  const currentUserTypeId = localStorage.getItem("userTypeId");
  const currentUserRoleId = userData?.userTypes?.find(
    (type) => type?.userTypeId == currentUserTypeId
  );

  const roleId = currentUserRoleId?.userTypeRoleId;
  const showDialogBox = (project, rowData) => {
    setSelectedProject(project);
    setSelectedRowData(rowData);
    setVisible(true);
  };
  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const showDialogBox1 = (project, rowData) => {
    setSelectedProject1(project);
    setVisible1(true);
  };
  const showDialogBox2 = (project, rowData) => {
    setSelectedProject2(project);
    setVisible2(true);
  };

  const renderDialog = () => {
    if (!selectedProject || !selectedRowData) return null;
    // Check if any projectType has projects
    const hasProjects = selectedRowData.userProjects?.some(
      (projectType) => projectType.projects?.length > 0
    );

    // If no projectType has projects, don't show the dialog box
    if (!hasProjects) return null;
    return (
      <Dialog
        visible={visible}
        onHide={() => setVisible(false)}
        className="p-dialog-sm p-fluid headerForProjectList  "
        header="Projects List"
        contentClassName="p-0"
        breakpoints={{ "960px": "75vw", "641px": "95vw", "480px": "100vw" }}
        style={{ width: "50vw", maxWidth: "800px" }}
        modal
      >
        <div className="p-3 surface-section">
          {selectedRowData.userProjects?.map(
            (projectType, index) =>
              // Render only if projectType has projects
              projectType.projects?.length > 0 && (
                <div key={index} className="mb-3 p-2">
                  <h2 className="text-xl font-semibold mb-2">
                    {projectType.projectType}
                  </h2>
                  <div className="flex flex-wrap gap-2">
                    {projectType.projects.map((project) => (
                      <span
                        key={project.projectId}
                        className="surface-ground border-round-2xl font-medium text-blue-900 p-2 p-tag"
                      >
                        {project.name}
                      </span>
                    ))}
                  </div>
                </div>
              )
          )}
        </div>
      </Dialog>
    );
  };
  const renderDialog1 = () => {
    if (!selectedProject1?.length) return null;

    return (
      <Dialog
        visible={visible1}
        onHide={() => setVisible1(false)}
        header="Projects List"
        modal
        className="p-dialog-sm p-fluid headerForProjectList"
        style={{ width: "50vw", maxWidth: "800px" }}
      >
        <div className="p-3 surface-section">
          <div className="flex flex-wrap gap-2">
            {[
              ...new Map(
                selectedProject1.map((item) => [item.projectId, item])
              ).values(),
            ].map((entry, index) => (
              <span
                key={entry.projectId}
                className="surface-ground border-round-2xl font-medium text-blue-900 p-2 p-tag"
              >
                {entry.projectName}
              </span>
            ))}
          </div>
        </div>
      </Dialog>
    );
  };
  const renderDialog2 = () => {
    if (!selectedProject2?.length) return null;

    return (
      <Dialog
        visible={visible2}
        onHide={() => setVisible2(false)}
        header="Projects List"
        modal
        className="p-dialog-sm p-fluid headerForProjectList"
        style={{ width: "50vw", maxWidth: "800px" }}
      >
        <div className="p-3 surface-section">
          <div className="flex flex-wrap gap-2">
          {selectedProject2?.map((entry, index) => (
              <span
                key={index}
                className="surface-ground border-round-2xl font-medium text-blue-900 p-2 p-tag"
              >
                {entry}
              </span>
            ))}
          </div>
        </div>
      </Dialog>
    );
  };
  const [selectedRows, setSelectedRows] = useState([]);

  const renderColumn = (col, rowData) => {
    switch (col.type) {
      case ColumnType.COUNTER:
        const maxWidthForPorjectNames = col.width || "200px";
        return (
          <div
            onClick={() => showDialogBox(rowData[col.field], rowData)}
            className="overflow-x-auto overflow-y-hidden whitespace-nowrap cursor-pointer "
            style={{ maxWidth: "200px", cursor: "pointer" }}
          >
            <div
              className="text-overflow-ellipsis overflow-hidden white-space-nowrap cursor-pointer"
              style={{ maxWidth: maxWidthForPorjectNames }}
            >
              {rowData[col.field].slice(0, 2)?.map((item, index) => (
                <span key={index} className="ml-1">
                  <u
                    style={{
                      textDecoration: "underline",
                      textDecorationColor: "blue",
                      color: "blue",
                    }}
                  >
                    {item}
                  </u>
                  {index < rowData[col.field]?.slice(0, 2)?.length - 1
                    ? ", "
                    : ""}
                </span>
              ))}
              {/* {rowData[col.field].length > 2 && (
                <span className='surface-200 border-round-xl border-1 px-3 py-1 inline-block'>+{rowData[col.field].length - 2}</span>
              )} */}
            </div>
          </div>
        );
      case ColumnType.projects:
        const entries =
          [
            ...new Map(
              rowData.entries.map((item) => [item.projectId, item])
            ).values(),
          ] || [];

        return (
          <div
            className="list-text-ellipsis"
            style={{ maxWidth: "180px", cursor: "pointer" }}
            onClick={() => showDialogBox1(entries, rowData)}
          >
            {entries.slice(0, 2).map((entry, index) => (
              <span key={index}>
                <u style={{ color: "blue" }}>{entry.projectName}</u>
                {index < entries.length - 1 ? ", " : ""}
              </span>
            ))}
            {entries.length > 2 && (
              <span className="ml-2 text-gray-500">
                +{entries.length - 2} more
              </span>
            )}
          </div>
        );
        case ColumnType.projects1:
          const entry = rowData?.projects||[];
          return (
            <div
              className="list-text-ellipsis"
              style={{ maxWidth: "260px", cursor: "pointer" }}
              onClick={() => showDialogBox2( entry, rowData)}
            >
              {rowData?.projects.slice(0, 2).map((entry, index) => (
                <span key={index}>
                  <u style={{ color: "blue" }}>{entry}</u>
                  {index < rowData?.projects?.length - 1 ? ", " : ""}
                </span>
              ))}
              {rowData?.projects.length > 2 && (
                <span className="ml-0 text-gray-500">
                  +{rowData?.projects.length - 2} more
                </span>
              )}
            </div>
          );
      case ColumnType.DATE:
        const rawDate = rowData[col.field];
        if (!rawDate) return ""; // Fallback if date is missing
        const date = new Date(rowData[col.field]);
        const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const dd = String(date.getDate()).padStart(2, "0");
        const yy = String(date.getFullYear()).slice(-2);
        return `${mm}/${dd}/${yy}`;
      case ColumnType.SUBTEXT:
        const content1 = rowData[col.field];
        const content2 = rowData["email"];
        const maxWidth = col.width || "200px";
        const id = `tooltip-${col.field}-${Math.random()
          .toString(36)
          .substr(2, 9)}`;
        const needsTooltip = content1?.length > 25;
        const ellipsisStyle = {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "200px",
          display: "inline-block",
        };

        return (
          <>
            <div
              id={needsTooltip ? id : undefined}
              style={ellipsisStyle}
              className="block"
            >
              <span className="text-800">{content1}</span>
            </div>
            <div style={ellipsisStyle}>
              <span className="text-500 email_text">{content2}</span>
            </div>
            {needsTooltip && (
              <Tooltip target={`#${id}`} position="top">
                {content1} <br />
                {content2}
              </Tooltip>
            )}
          </>
        );
      case ColumnType.Status:
        return statusBodyTemplate(rowData);
      case ColumnType.projectType:
        return rowData["userTypeId"] == 2
          ? "External"
          : rowData["userTypeId"] == 1
          ? "Internal"
          : "All Projects";
      case ColumnType.TEXT:
      default:
        const content = rowData[col.field];
        const maxWidth1 = col.width || "200px";
        const id1 = `tooltip-${col.field}-${Math.random()
          .toString(36)
          .substr(2, 9)}`;
        const needsTooltip1 = content?.length > 25; // Approximate length where text might overflow

        return (
          <>
            <div
              id={needsTooltip1 ? id1 : undefined}
              className="text-overflow-ellipsis overflow-hidden white-space-nowrap"
              style={{ maxWidth: maxWidth1 }}
            >
              {content}
            </div>
            {needsTooltip1 && (
              <Tooltip target={`#${id1}`} position="top">
                {content}
              </Tooltip>
            )}
          </>
        );
    }
  };
    const handleEmailTrigger = (data) => {
      try {
        confirmDialog({
          message: "Are you sure you want to send mail notification",
          header: "Confirm Approval",
          icon: "pi pi-check-circle",
          acceptClassName: "p-button-success",
          accept: () => sendEmails(data),
          reject: () => {},
        });
      } catch (error) {}
    };
  const sendEmails=async (data)=>{
    setCopyProgressBar(true)
    try{
      if (typeof data[0]?.year !== "number" || typeof data[0]?.month !== "number") {
        //  TODO: add toast
        toast?.current?.show({
          severity: "error",
          summary: "Error",
          detail: `Please select a year and month before sending mail.`,
          life: 3000,
        });
        return;
      }
      const userIds =
      data?.map((x)=>x?.id)
      let result = await sendEmailNotification(data[0]?.year,data[0]?.month,currentUserTypeId,userIds)
      if(result){
        toast?.current?.show({
          severity: "success",
          summary: "Successful",
          detail: `${result}`,
          life: 3000,
        });
  
      }
    }catch(error){
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message ? error?.message:
          error?.status === 400
            ? "User not Found"
            : error?.status === 500
            ? "Internal Server Error"
            : error?.status === 404
            ? "User not Found"
            : "Error occurred while submitting details",
        life: 5000,
      });
      appInsights.trackException("Time Summary screen: Email trigger function failure", { exception: error });
    }
    setCopyProgressBar(false)
  }
  // Track pagination



  return (
    <div className="card">

      {renderDialog()}
      {renderDialog1()}
      {renderDialog2()}
      <Toast ref={toast} position="top-center" />
      <DataTable
        value={data}
        tableStyle={{ ...tableStyle, minWidth: "50rem" }}
        scrollable
        scrollHeight="400px"
        totalRecords={data?.length}
        className={`${tableStyle?.dataTable}`}
        header={header && header()}
        paginator
        rows={rows}
       
        rowsPerPageOptions={[5, 10, 25, 50]}
        emptyMessage={emptyMessage}
        showPageLinks={true}
        pageLinkSize={5}
        {
    // Conditionally spread props only if all required for lazy loading are present
    ...(totalRecords && onPage && first
      ? {
          totalRecords,
          onPage,
          first,
          lazy: true,
        }
      : {})
  }
        selection={selectedRows}
        onSelectionChange={(e) => setSelectedRows(e.value)} 

        paginatorLeft={
          checkBox && ( // ✅ Render button only if checkBox is true and rows selected
            <div className="flex justify-content-end p-3">
              <Button
                className="sendByIdBtn"
                icon="pi pi-send"
                rounded
                text
                label="Send email to everyone"
                severity="info"
                disabled={! selectedRows?.length > 0}
                onClick={() => handleEmailTrigger(selectedRows)}
              />
            </div>
          )
        }
        selectionMode="checkbox" 
      >
          {checkBox && (
          <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
        )}
        {columns?.map((col) => (
          <Column
            key={col.field}
            field={col.field}
            header={col.header}
            sortable={col.sortable}
            filter={col.filterable}
            frozen={col.frozen}
            style={{
              minWidth: col.width,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
                  ...(col.frozen && {
        zIndex: 1, // LOWER z-index for body cells
        position: 'sticky',
        left: 0,
        background: '#fff',
      }),
            }}
      headerStyle={{
              minWidth: col.width,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              ...(col.frozen && {
        zIndex: 3, // HIGHER z-index for header
        position: 'sticky',
        top: 0,
          background: '#f8f9fa;' ,
      }),
            }}
            body={(rowData) => renderColumn(col, rowData)}
          />
        ))}
        {actions?.status?.enabled && (
          <Column
            header={actions.status.label}
            body={(rowData) =>
              renderActionColumn(rowData, actions.status.label)
            }
            style={{
              minWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            headerStyle={{
              minWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          />
        )}
        {actions?.menu?.enabled && (
          <Column
            header={actions.menu.label}
            body={(rowData) => renderActionColumn(rowData, actions.menu.label)}
            style={{
              minWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            headerStyle={{
              minWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          />
        )}

        {actions?.download?.enabled && (
          <Column
            header={actions.download.label}
            body={(rowData) =>
              renderActionColumn(rowData, actions.download.label)
            }
            style={{
              minWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            headerStyle={{
              minWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          />
        )}
        {actions?.view?.enabled && (
          <Column
            header={actions.view.label}
            body={(rowData) => renderActionColumn(rowData, actions.view.label)}
            style={{
              minWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            headerStyle={{
              minWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          />
        )}
        {actions?.email?.enabled && (
          <Column
            header={actions.email.label}
            body={(rowData) => renderActionColumn(rowData, actions.email.label)}
            style={{
              minWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            headerStyle={{
              minWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          />
        )}
        {actions?.approval?.enabled && (
          <Column
            header={actions.approval.label}
            body={(rowData) =>
              renderActionColumn(rowData, actions.approval.label)
            }
            style={{
              minWidth: "140px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            headerStyle={{
              minWidth: "140px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          />
        )}
      </DataTable>
      {progressBar && <Spinner />}
    </div>
  );
}

export default Table;
